import { render, staticRenderFns } from "./Ylmf.vue?vue&type=template&id=27a71def&scoped=true&"
import script from "./Ylmf.vue?vue&type=script&lang=js&"
export * from "./Ylmf.vue?vue&type=script&lang=js&"
import style0 from "./Ylmf.vue?vue&type=style&index=0&id=27a71def&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a71def",
  null
  
)

export default component.exports